export const COLORS = {
  WHITE: "#fff",
  BLACK: "#212934",
  BLUE: "#80C9CC",
  CYAN: "#01B489",
  CYAN_SECONDARY: "#00B488",
  DARKCYAN: "#00767C",
  DARKGREY: "#4B617C",
  LIGHTGREEN: "#259D58",
  DARKGREEN: "#145239",
  PRIMARY: "#009299",
  ERROR: "#C43131",
  BACKGROUND: "#F8F9FA",
  BLUEALERTS: "#E3F0FC",
  GREENALERTS: "#E9F7E9",
  GREYSHADE: "#E5E5E5",
  SHADE_500: "#B8C4CE",
  SHADE_300: "#E1E7EC",
};
